import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from '../styles/views/PrivacyPolicy.module.scss';

const PrivacyPolicy: React.FC = () => {
  const [privacyContent, setPrivacyContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadPrivacyPolicy = async () => {
      try {
        const response = await fetch('/privacy-policy.md');
        if (!response.ok) {
          throw new Error('Failed to load Privacy Policy');
        }
        const content = await response.text();
        setPrivacyContent(content);
      } catch (error) {
        console.error('Error loading Privacy Policy:', error);
        setError('Failed to load Privacy Policy');
      } finally {
        setIsLoading(false);
      }
    };

    loadPrivacyPolicy();
  }, []);

  return (
    <div className={styles.privacyContainer}>
      <div className={styles.privacyHeader}>
        <h1 className={styles.privacyTitle}>Privacy Policy</h1>
        <p className={styles.privacySubtitle}>
          Learn how Liquid Credit collects, uses, and protects your information.
        </p>
      </div>

      <div className={styles.privacyContent}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <div className={styles.spinner}></div>
            <p>Loading Privacy Policy...</p>
          </div>
        ) : error ? (
          <div className={styles.errorContainer}>
            <p>Error loading Privacy Policy. Please try again later.</p>
          </div>
        ) : (
          <div className={styles.markdownContent}>
            <ReactMarkdown>
              {privacyContent}
            </ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
